import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Guard from './components/Guard';
import Credenciais from './pages/Credenciais';
import Fila from './pages/Fila';
import Detalhe from './pages/Detalhe';
import Videos from './pages/Videos';
import VideoDetalhe from './pages/VideoDetalhe';

export default function App() {
  return (
    <Routes>
      <Route path="/credenciais" element={<Credenciais />} />

      <Route element={<Guard><Layout /></Guard>}>
        <Route index element={<Fila />} />
        <Route path="/transcricoes/:id" element={<Detalhe />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/videos/:id" element={<VideoDetalhe />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
